import React, { Component } from "react";
import { observer } from "mobx-react";
import home from "../../store/index.js";

import question from "../../static/images/question.png";
import pepole from "../../static/images/pepole.png";
import emli from "../../static/images/emli.png";
import answer from "../../static/images/answer.png";
import guide from "../../static/images/guide.png";
import guideActive from "../../static/images/guideactive.png";
import qustionactive from "../../static/images/qustionactive.png";
import pepoleActive from "../../static/images/pepoleActive.png";
import emailActive from "../../static/images/emailActive.png";
import answerselect from "../../static/images/answerselect.png";
import { withRouter } from "react-router-dom";
import "./index.css";
@observer
class Tab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathName: props.location.pathname,
      num: 0,
    };
  }
  change(item) {
    this.props.history.push(`/${item}`);
  }
  componentDidMount() {
    home.GetGroupId();
  }
  render() {
    return (
      <div className="tap">
        <div
          className="tap_ct"
          onClick={() => {
            this.change("guide");
          }}
        >
          <i>
            <img
              src={this.state.pathName === "/guide" ? guideActive : guide}
              alt=""
            />
          </i>
          <span className={this.state.pathName === "/guide" ? "guide_tab" : ""}>
            成长圈
          </span>
        </div>
        <div
          className="tap_ct"
          onClick={() => {
            this.change("person");
          }}
        >
          <i>
            <img
              src={this.state.pathName === "/person" ? pepoleActive : pepole}
              alt=""
            />
          </i>
          <span
            className={this.state.pathName === "/person" ? "person_tab" : ""}
          >
            解忧人
          </span>
        </div>
        {/* 不属于解忧组就不能看问题这个按钮 */}
        {home.isGroup ? (
          <div
            className="tap_ct"
            onClick={() => {
              this.change("anwser");
            }}
          >
            <i>
              <img
                src={this.state.pathName === "/anwser" ? answerselect : answer}
                alt=""
              />
            </i>
            <span
              className={
                this.state.pathName === "/anwser" ? "question_tab" : ""
              }
            >
              回答问题
            </span>
          </div>
        ) : (
          ""
        )}
        <div
          className="tap_ct"
          onClick={() => {
            this.change("writelitter");
          }}
        >
          <i>
            <img
              src={
                this.state.pathName === "/writelitter"
                  ? qustionactive
                  : question
              }
              alt=""
            />
          </i>
          <span
            className={
              this.state.pathName === "/writelitter" ? "question_tab" : ""
            }
          >
            我要提问
          </span>
        </div>
        <div
          className="tap_ct"
          onClick={() => {
            this.change("mymailbox");
          }}
        >
          <i>
            <img
              src={this.state.pathName === "/mymailbox" ? emailActive : emli}
              alt=""
            />
          </i>
          <span
            className={
              this.state.pathName === "/mymailbox" ? "mymailbox_t" : ""
            }
          >
            我的信箱
          </span>
          {home.unReadnum !== 0 ? <div>{home.unReadnum}</div> : ""}
        </div>
      </div>
    );
  }
}
export default withRouter(Tab);
